<template>
  <mu-appbar style="width: 100%;" color="primary">
    Eromed :: Dropshipping

    <mu-button flat slot="right" to="/login" v-if="!loggedIn"
      >LOGOWANIE</mu-button
    >
    <mu-button flat slot="right" to="/dashboard" v-if="loggedIn"
      >PANEL</mu-button
    >
    <mu-button flat slot="right" to="/logout" v-if="loggedIn"
      >WYLOGUJ</mu-button
    >
  </mu-appbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapGetters("user", ["loggedIn"])
  }
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}
</style>
